import React, { useEffect, useState, useCallback } from "react";
import { ProductDetail } from "src/features/products/model/ProductWithVariant";
import { useGetProductDetailQuery } from "src/features/products/productsQuery";
import { useAppDispatch } from "src/shared/hooks/redux";
import makeFetchUrl from "src/shared/util/make-fetch-url";
import toggleURLSearchParams from "src/shared/util/toggle-url-search-params";
import { clearAllModalErrors } from "../productModalSlice";
interface UseProductDetailProps {
  url?: string;
  params?: URLSearchParams;
}

function useProductDetail({ url, params }: UseProductDetailProps): {
  data: ProductDetail | undefined;
  isLoading: boolean;
  isError: boolean;
  isFetching: boolean;
  toggleParams: (key: string, value: string) => void;
  resetParams: () => void;
} {
  const [searchParams, setSearchParams] = useState<URLSearchParams>(
    params ?? new URLSearchParams("?format=json")
  );
  const dispatch = useAppDispatch();
  const { data, isLoading, isError, isFetching } = useGetProductDetailQuery(
    { url: makeFetchUrl(url, searchParams) },
    { skip: !url }
  );

  useEffect(() => {
    if (data) {
      dispatch(clearAllModalErrors());
    }
  }, [data, dispatch]);

  const toggleParams = useCallback(
    (key: string, value: string) => {
      const newVariantUrlParams = toggleURLSearchParams(
        searchParams,
        key,
        value
      );
      setSearchParams(newVariantUrlParams);
    },
    [searchParams]
  );

  const resetParams = useCallback(() => {
    setSearchParams(new URLSearchParams("?format=json"));
  }, []);

  return {
    data: data,
    isLoading,
    isError,
    isFetching,
    toggleParams,
    resetParams,
  };
}

export default useProductDetail;
